module.exports = {
    RECEIVE_QUALITOMETER_NETWORK_ALL: 'RECEIVE_QUALITOMETER_NETWORK_ALL',
    RECEIVE_ALL_NETWORK: 'RECEIVE_ALL_NETWORK',
}